import React from 'react';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { FormModalContainer, FormModalContent } from './style';
import { PlainUserRow } from '../../Rows/PlainUserRow';

export const BirthdaysModal = ({ onClose, date, birthdays }) => {
    return (
        <FormModalContainer>
            <FormModalContent>
                <Text alignCenter fontSize={22} marginBottom={'10px'} weight={'bold'}>
                    Member’s birthdays 🎉
                </Text>
                <Text alignCenter marginBottom={'30px'}>
                    {date}
                </Text>
                <CloseIconContainer onClick={onClose}>
                    <i className="fas fa-times" />
                </CloseIconContainer>

                {birthdays.map((bday, index) => (
                    <PlainUserRow key={index} {...bday} />
                ))}
            </FormModalContent>
        </FormModalContainer>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/BirthdaysModal/index.js